/* template */
<template minapp="mpx" xlang="wxml"><div class="mpx-root-view"><mpx-view @tap="changeModel" class="change-box"><div :style="[(tools.btnStyle('Chinese',innerValue))] | transRpxStyle" class="change-box-CN">中</div><div :style="[(tools.btnStyle('english',innerValue))] | transRpxStyle" class="change-box-ENG">EN</div></mpx-view></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mb8b68426"}'>
.change-box
  width: 74px;
  height: 22px;
  background: #FFFFFF;
  border: 1px solid #E5E5E5;
  border-radius: 6px;
  display: flex;
  font-family: PingFangSC-Regular;
  font-size: 12px;
.change-box-CN
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 22px;
  background: #1473FF;
  border-radius: 6px;
  color: #FFFFFF;
.change-box-ENG
  width: 38px;
  height: 22px;
  border-radius: 6px;
  display: flex
  align-items: center;
  justify-content: center;
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  wxsModules.tools = require("./change-btn.mpx.wxs!=!./change-btn.mpx?wxsModule=tools")
  global.currentModuleId = "mb8b68426"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./change-btn.mpx.js?isComponent&outputPath=components%2Fchange-btnb8b68426%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./change-btn.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fchange-btnb8b68426%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mb8b68426"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/change-btnb8b68426/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
